import { features } from 'constants/featureFlags';
import Button from 'koba/components/Button';
import { useTranslation } from 'react-i18next';

import React, { ReactNode } from 'react';

import { useCommunityContext } from 'components/CommunityContext';
import EmptyStateCard from 'components/InfoCard/EmptyStateCard/EmptyStateCard';

interface CreatePostCardProps {
  title: string;
  content: ReactNode;
  imageSrc: string;
  dataQA?: string;
  onClick?: () => void;
}

const CreatePostCard = ({
  onClick,
  title,
  content,
  dataQA = 'create-post-card',
  imageSrc,
}: CreatePostCardProps) => {
  const { t } = useTranslation();
  const { community, featureFlags } = useCommunityContext();
  const tiptapEditorEnabled = featureFlags[features.TIPTAP_EDITOR];

  const handleClick = () => {
    let post = document.querySelector('#post-form__title');
    if (tiptapEditorEnabled) {
      post = document.querySelector('.tiptap');
    }
    if (post) {
      (post as HTMLInputElement).focus();
      post.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    onClick?.();
  };

  const createPostCardButton = (
    <Button
      appearance="default"
      ariaLabel={t(
        'components-infoCard-createPostCard-call_to_action_aria_label',
        'Click to create a post'
      )}
      color={community.primaryColor}
      data-qa={`${dataQA}__button-create`}
      key="create-post-card__button-create"
      onClick={handleClick}
    >
      {t('components-infoCard-createPostCard-create_post_button_text', 'Create post')}
    </Button>
  );

  return (
    <EmptyStateCard
      content={content}
      dataQA={dataQA}
      emptyStateAction={createPostCardButton}
      imageSrc={imageSrc}
      title={title}
      hasAdminSection
    />
  );
};

export default CreatePostCard;
